export enum EPurchaseActivityTabs {
  PREVIOUS_ORDERS   = 'previous-orders',
  PENDING_ORDERS    = 'pending-orders',
  PREVIOUS_QUOTES   = 'previous-quotes',
  PREVIOUS_REQUESTS = 'previous-requests',
  SERVICES          = 'services'
}

export enum EPurchaseActivityPreviousOrdersTabs {
  ORDERS  = 'orders',
  ARCHIVE = 'archive'
}

export enum EPurchaseActivityEndpoints {
  PREVIOUS_ORDERS   = 'previous-orders',
  ARCHIVE_ORDERS    = 'archive-orders',
  PENDING_ORDERS    = 'pending-orders',
  PREVIOUS_QUOTES   = 'previous-quotes',
  PREVIOUS_REQUESTS = 'previous-requests',
}

export enum EResourceType {
  ORDER   = 'order',
  QUOTE   = 'quote',
  REQUEST = 'request',
}

export enum EPurchaseActivityDetailsPageFieldNames {
  FUNCTIONAL_LOCATION = 'functionalLocation',
  SOLD_TO_ADDRESS     = 'soldToAddress',
  SHIP_TO_ADDRESS     = 'shipToAddress',
  BILL_TO_ADDRESS     = 'billToAddress',
  PAYER_ADDRESS       = 'payerAddress',
  EMAIL               = 'email',
  PHONE_NUMBER        = 'phoneNumber',
  SHIPMENT_METHOD     = 'shipmentMethod',
  PAYMENT_METHOD      = 'paymentMethod',
  TAX_NUMBER          = 'taxNumber',
  PO_NUMBER           = 'poNumber',
  RETURN_ORDER_NUMBER = 'returnOrderNumber',
}

export enum EPurchaseActivityDetailsPagePriceFieldNames {
  SUBTOTAL  = 'subtotal',
  EXPENSE   = 'expense',
  TAX       = 'tax',
  DISCOUNTS = 'discounts',
}

export enum EPurchaseActivityDetailsPageOrderItemFieldNames {
  STATUS                = 'status',
  DELIVERY_AVAILABILITY = 'deliveryAvailability',
  ESTIMATED_DELIVERY    = 'estimatedDelivery',
  TRACKING_NUMBERS      = 'trackingNumbers',
}
